<template>
  <div class="pratice-sensitive-topics-content" id="identidade-verbal-na-pratica-gestao-de-crise" data-search-anchor>
      <h1 class="pratice-sensitive-topics-title">
          {{ praticeSensitiveTopicsTitle }}
        </h1>               

        <div class="pratice-sensitive-topics-wrapper">

            <div class="pratice-sensitive-topics-crise-container">
                <p class="pratice-sensitive-paragraph-title">{{ praticeReleaseParagraphTitle }}</p>
                <p class="pratice-sensitive-paragraph">{{ praticeReleaseParagraph1 }}</p>                        
                <p class="pratice-sensitive-paragraph">{{ praticeReleaseParagraph2 }}</p>                
                <p class="pratice-sensitive-paragraph">{{ praticeReleaseParagraph3 }}</p>                                                        
            </div>

            <div class="pratice-sensitive-topics-tips-container">
                <p class="pratice-sensitive-topics-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-sensitive-topics-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-sensitive-topics-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <ThreeCircles />

                <div class="pratice-legend-sensitive-topics-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph5 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph6 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeSensitiveTopicsSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeSensitiveTopicsTitle(): string {
    return this.getElementTitle(8, 0)
  }

  get praticeReleaseParagraphTitle(): string {
    return this.getElementText(8, 0)
  }

  get praticeReleaseParagraph1(): string {
    return this.getElementText(8, 1)
  }

  get praticeReleaseParagraph2(): string {
    return this.getElementText(8, 2)
  }

  get praticeReleaseParagraph3(): string {
    return this.getElementText(8, 3)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(8, 4)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(8, 5)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(8, 6)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(8, 7)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(8, 8)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(8, 9)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(8,  10)
  }
  
  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-sensitive-topics-content {
  display: grid;
  justify-content: center;
  margin-top: 80px;  
  max-width: 1032px;
}

.pratice-sensitive-topics-title {
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
  text-align: left;
  margin: 0;
  width: 100%;
}

.pratice-sensitive-topics-wrapper {
  position: relative; 
  display: grid;
  grid-template-columns: repeat(2, 495px);
  column-gap: 42px;
  margin-top: 50px;
}

.pratice-sensitive-topics-crise-container {
  width: 506px;
  height: 712px;
  border-radius: 16px; 
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
  white-space: pre;
}

.pratice-sensitive-topics-tips-container {
  width: 506px;
  height: 712px;    
}

.pratice-sensitive-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-sensitive-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
  white-space: pre;
}

.pratice-sensitive-topics-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 94px;
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-sensitive-topics-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-sensitive-topics-paragraph:nth-child(5) {
  margin-top: 94px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  font-size: 16px;  
  line-height: 24px;
  margin: 0;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-sensitive-topics-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 167px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
